import { Injectable } from '@angular/core';

@Injectable()
export class GameService {
    constructor() {
    }

    get_gamer_info(info: any) { // 게임에 참여한 사용자의 승률 정보를 리턴한다.
        const rtn = {info, win_progress: 0, win_red: 0, win_blue: 0, gain_progress: 0, gain_red: 0, gain_blue: 0};

        try {
            const objInfo = JSON.parse(info);

            if (objInfo.total_game === null) {
                objInfo.total_game = 0;
            }
            if (objInfo.total_point === null) {
                objInfo.total_point = 0;
            }
            if (objInfo.win_game === null) {
                objInfo.win_game = 0;
            }
            if (objInfo.win_point === null) {
                objInfo.win_point = 0;
            }
            rtn.info = objInfo;

            if (objInfo.total_game === 0) {
                rtn.win_red = 0;
                rtn.win_blue = 0;
                rtn.win_progress = 0;

                rtn.gain_red = 0;
                rtn.gain_blue = 0;
                rtn.gain_progress    = 0;
            } else {

                let tmpWriter = objInfo.win_game / objInfo.total_game;
                rtn.win_red = (tmpWriter * 100);
                rtn.win_blue = 100 - (tmpWriter * 100);
                rtn.win_progress = rtn.win_blue / 2;

                tmpWriter = objInfo.win_point / objInfo.total_point;
                rtn.gain_red = (tmpWriter * 100);
                rtn.gain_blue = 100 - (tmpWriter * 100);
                rtn.gain_progress = rtn.gain_blue / 2;
            }
        } catch (e) {
            console.log(e);
        }
        return rtn;
    } // init: function(){

}
